module.exports = __webpack_public_path__ + "static/media/hand.9e0fc6a5.png";